"use client";

import React, { useState } from 'react';
import Link from 'next/link';
import styles from '@/styles/Header.module.css';
import ThemeToggle from '@/components/common/ThemeToggle';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <div className={styles.logo}>
          <Link href="/" title="TimeLee Cares Foundation - Return to homepage">
            <span className={styles.logoText}>TimeLee Cares Foundation, Inc.</span>
          </Link>
        </div>
        
        <nav className={`${styles.nav} ${isMenuOpen ? styles.active : ''}`}>
          <ul className={styles.navLinks}>
            <li><Link href="/" title="Return to homepage" onClick={() => setIsMenuOpen(false)}>Home</Link></li>
            <li><Link href="/about" title="Learn about TimeLee Cares Foundation" onClick={() => setIsMenuOpen(false)}>About</Link></li>
            <li><Link href="/programs" title="View our programs and services" onClick={() => setIsMenuOpen(false)}>Programs</Link></li>
            <li><Link href="/blog" title="Read our blog posts and updates" onClick={() => setIsMenuOpen(false)}>Blog</Link></li>
            <li><Link href="/resources" title="Access helpful resources for students" onClick={() => setIsMenuOpen(false)}>Resources</Link></li>
            <li><Link href="/donate" title="Support our mission with a donation" onClick={() => setIsMenuOpen(false)}>Donate</Link></li>
            <li><Link href="/contact" title="Get in touch with us" onClick={() => setIsMenuOpen(false)}>Contact</Link></li>
            <li className={styles.themeToggleWrapper}>
              <ThemeToggle onThemeChange={() => setIsMenuOpen(false)} />
            </li>
          </ul>
        </nav>

        <button
          className={styles.mobileMenuButton}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label={isMenuOpen ? "Close navigation menu" : "Open navigation menu"}
          title={isMenuOpen ? "Close menu" : "Open menu"}
          aria-expanded={isMenuOpen}
        >
          <span className={styles.hamburger}></span>
        </button>
      </div>
    </header>
  );
};

export default Header; 